import { RmaPaymentProps, stateStatusType } from "./actionType";

export interface FetchPaymentState {
  isLoading: boolean;
  error: string | null;
  rmaPaymentResponse: RmaPaymentProps[] | []; // list
  stripePaymentResponse: RmaPaymentProps[] | []; // list
  inAppPurchaseResponse: RmaPaymentProps[] | []; // list
  status: stateStatusType | null;
}



export const initalFetchPaymentState: FetchPaymentState = {
  isLoading: false,
  error: null,
  rmaPaymentResponse: [],
  stripePaymentResponse: [],
  inAppPurchaseResponse: [],
  status: null,
};



export interface PaymentState {
  fetchPaymentState: FetchPaymentState;
}

export const initialState: PaymentState = {
  fetchPaymentState: initalFetchPaymentState,
}

